<template>
  <div id="ebScreen">
    <div v-for="(item, index) in screenDatas" @click="ScreenClick(item.content,$event)" :style="{'backgroundImage':index==0?redBgImg:grayBgImg}" :key="item.text" class="screen-content">{{item.text}}</div>
  </div>
</template>

<script>
import $ from 'jquery';
export default {
  name: 'ebScreen',
  props: ['typeFilterData'],
  data() {
    return {
      screenDatas: this.typeFilterData,
      redBgImg: 'url(' + require('@/assets/img/screen-red.jpg') + ')',
      grayBgImg: 'url(' + require('@/assets/img/screen-gray.jpg') + ')'
    };
  },
  methods: {
    ScreenClick: function(data, event) {
      $(event.target)
        .css('backgroundImage', this.redBgImg)
        .siblings('div')
        .css('backgroundImage', this.grayBgImg);

      this.$emit('getTypeFilterData', data);
    }
  }
};
</script>
<style scoped lang="less">
#ebScreen {
  display: flex;
  flex-wrap: wrap;
  .screen-content {
    box-sizing: border-box;
    height: 42px;
    width: 81px;
    text-align: center;
    line-height: 42px;
    padding-right: 7px;
    float: left;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
    background-repeat: no-repeat;
    font-family: 'Microsoft YaHei'
  }
}
</style>
